import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterMatchMode, FilterMetadata, FilterOperator, SelectItem } from 'primeng/api';
import { Tenant } from '../../../../model/tenant';
import { EntityWithUuid } from '../../../../model/custom/entity-with-uuid';
import { AssetMeasurement } from '../../../../model/asset-measurement';
import { TenantsService } from '../../../../services/tenants.service';
import { AssetsService } from '../../../../services/assets.service';
import { MeasurementType } from '../../../../model/measurement-type';

@Component({
  selector: 'app-asset-measurements-step',
  templateUrl: './asset-measurements-step.component.html',
  styleUrls: ['./asset-measurements-step.component.scss']
})
export class AssetMeasurementsStepComponent implements OnInit {

  @Input() tenant: Tenant;
  @Input() selectionMode: 'single' | 'multiple';
  @Input() assetSelection: EntityWithUuid | EntityWithUuid[];
  @Input() assetMeasurementSelection: AssetMeasurement | AssetMeasurement[];
  @Input() assetMeasurementFilters: {[field: string]: FilterMetadata};
  @Output() assetMeasurementSelectionChange: EventEmitter<AssetMeasurement | AssetMeasurement[]>;
  @Output() assetMeasurementFiltersChange: EventEmitter<{ [field: string]: FilterMetadata }>;

  public measurements: AssetMeasurement[];
  public measurementTypes: SelectItem[];
  public selectedMeasurementTypeSensors: string[];
  public loadingAssetMeasurements: boolean;
  public first: number;
  public rows: number;

  constructor(
    private tenantsService: TenantsService,
    private assetsService: AssetsService
  ) {
    this.assetMeasurementSelectionChange = new EventEmitter<AssetMeasurement | AssetMeasurement[]>();
    this.assetMeasurementFiltersChange = new EventEmitter<{ [ field: string ]: FilterMetadata }>();
    this.selectedMeasurementTypeSensors = [];
    this.loadingAssetMeasurements = true;
    this.first = 0;
    this.rows = 10;
  }

  ngOnInit(): void {
    this.loadingAssetMeasurements = true;
    this.selectedMeasurementTypeSensors = this.assetMeasurementFilters['measurementType.sensor']?.value ?? [];
    this.loadAssetMeasurements();
    this.loadAssetMeasurementTypes();
  }

  private loadAssetMeasurements(): void {
    if (this.selectionMode === 'multiple') {
      const arraySelection = this.assetSelection as EntityWithUuid[];
      const uuids: string[] = arraySelection.map(value => value.uuid);
      this.assetsService.getAssetMeasurementsOfAssets(uuids).subscribe(response => {
        this.measurements = response.assetMeasurements;
        this.loadingAssetMeasurements = false;
      });

    } else if (this.selectionMode === 'single') {
      const objectSelection = this.assetSelection as EntityWithUuid;
      this.assetsService.getAssetMeasurementsOfAssets([objectSelection.uuid]).subscribe(response => {
        this.measurements = response.assetMeasurements;
        this.loadingAssetMeasurements = false;
      });
    }
  }

  private loadAssetMeasurementTypes(): void {
    this.tenantsService.getTenantMeasurementTypes(this.tenant.uuid).subscribe(response => {
      this.measurementTypes = response.measurementTypes
        .sort((a, b) => a.sensor > b.sensor ? 1 : -1)
        .map((measurementType: MeasurementType) => ({ value: measurementType.sensor }));
      if (this.measurementTypes.length === this.selectedMeasurementTypeSensors?.length) {
        this.selectedMeasurementTypeSensors = [];
      }
    });
  }

  public beforeApplyFilters(): void {
    if (this.selectedMeasurementTypeSensors.length > 0) {
      this.assetMeasurementFilters['measurementType.sensor'] = {
        value: this.selectedMeasurementTypeSensors,
        matchMode: FilterMatchMode.IN,
        operator: FilterOperator.AND
      };
    } else {
      this.assetMeasurementFilters['measurementType.sensor'] = {
        value: this.measurementTypes.map(item => item.value),
        matchMode: FilterMatchMode.IN,
        operator: FilterOperator.AND
      };
    }
  }

}
